import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

interface UseTranslationReturn {
  t: (key: string) => string;
  currentLanguage: string;
}

export const useTranslation = (): UseTranslationReturn => {
  const { currentLanguage } = useLanguage();

  const t = (key: string): string => {
    return getTranslation(currentLanguage, key);
  };

  return { t, currentLanguage };
};
